
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'UI_Modal',
  props: {
    headerText: String,
    shown: Boolean
  }
})
